import { List } from 'immutable'
import { ParsedParagraphOpeningHours } from '../../../api/drupal/types'
import { OpeningHourProps } from './OpeningHoursTypes'

enum DrupalDaysOfWeek {
  Zondag = 0,
  Maandag = 1,
  Dinsdag = 2,
  Woensdag = 3,
  Donderdag = 4,
  Vrijdag = 5,
  Zaterdag = 6
}

// Unless someone changes the allowed values in Drupal (reflected in `DrupalDaysOfWeek`), we should
// never need this fallback.
const fallback: ParsedParagraphOpeningHours = {
  field_closed: false,
  field_opening_time: '0:00',
  field_closing_time: '0:00',
  field_additional_information: ''
} as ParsedParagraphOpeningHours

export const getDrupalCurrentOpeningHours = (openingHours: List<ParsedParagraphOpeningHours>): OpeningHourProps => {
  const currentDate = new Date()
  const dayOfWeek = currentDate.getDay()
  const hours = openingHours.find(h => h.field_day === DrupalDaysOfWeek[dayOfWeek], null, fallback)

  return {
    closed: hours.field_closed,
    readableTime: `${hours.field_opening_time} - ${hours.field_closing_time}`,
    additionalInformation: hours.field_additional_information
  }
}
